export default __webpack_public_path__ + "static/photo_programming-f93f9bd7af3bbb969ee85d0a9247583c.jpg";